import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import { getBusinessParterships, getBusinessPartnershipImages } from "../../actions/BusinessPages";
import { IMAGE_URL } from "../../path";

function BusinessPartners() {
    const location = useLocation();
    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }
    const user = location.state?.user;
    const [collapsed, setCollapsed] = useState(true);

    const [partnerships, setPartnerships] = useState<any[]>([]);
    const [partnershipImages, setPartnershipImages] = useState<any[]>([]);

    useEffect(() => {
        getBusinessParterships()
          .then(response => {
            setPartnerships(response.data);
          })
          .catch(error => {
            console.error("Failed to fetch business story:", error);
          });

        getBusinessPartnershipImages()
          .then(response => {
            setPartnershipImages(response.data);
          })
          .catch(error => {
            console.error("Failed to fetch business story:", error);
          });
    }, []);

    const handleEditTextSection = (partnership: any) => {

        navigate('/dashboard/business/partnership/edit', {
            state: {
                user,
                partnership
            }
        });
    };

    return (
        <div>
            <AdminHeader isCollapsed={collapsed} setIsCollapsed={setCollapsed} user={user} />
            <AdminNav collapsed={collapsed} setCollapsed={setCollapsed} user={user} />

            <div className={`main-admin-page ${collapsed ? 'collapsed' : 'expanded'}`}>
                {/* Text Section Table */}
                <div className="table-container">
                    <table className="home-images-table">
                        <thead>
                            <tr>
                                <th style={{ width: "70%" }}>Title</th>
                                <th style={{ width: "15%" }}>Display Order</th>
                                <th style={{ width: "15%" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {partnerships.length > 0 ? (
                                partnerships.map((partnership, index) => (
                                    <tr key={index}>
                                        <td>{partnership.title}</td>
                                        <td>{(partnership.position / 2)  *10}</td>
                                        <td>
                                            <button
                                                className="button small"
                                                onClick={() => {handleEditTextSection(partnership)}}
                                            >
                                                Edit
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={3}>No partnership sections found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <h2>Images</h2>
                <div className="table-container">
                    <table className="home-images-table">
                        <thead>
                            <tr>
                                <th style={{ width: "55%" }}>Main Image</th>
                                <th style={{ width: "15%" }}>Mobile Image</th>
                                <th style={{ width: "15%" }}>Display Order</th>
                                <th style={{ width: "15%" }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {partnershipImages.length > 0 ? (
                                partnershipImages.map((image, index) => (
                                    <tr key={index}>
                                        <td>
                                            <img
                                                src={IMAGE_URL + image.image}
                                                style={{ width: '800px' }}
                                                alt="Main Image"
                                            />
                                        </td>
                                        <td>
                                            <img
                                                src={IMAGE_URL + image.mobile_image}
                                                style={{ width: '340px' }}
                                                alt="Mobile Image"
                                            />
                                        </td>
                                        <td>{((image.position + 1) / 2) * 10}</td>
                                        <td>
                                            <button className="button small" onClick={() => {
                                                console.log(image);
                                                navigate('/dashboard/business/partnership/edit-images', {state: {user, image}})}}>Edit</button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4}>No partnership images found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default BusinessPartners;
